import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex gap-4" }
const _hoisted_2 = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-primary30"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary text-sm" }, "Reprovar", -1)
const _hoisted_4 = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-negative"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary text-sm" }, "Aprovar", -1)

type ApprovalStatus = 'approved' | 'rejected' | null


export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovalChoice',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const select = (value: ApprovalStatus) => {
  const newValue = props.modelValue === value ? null : value
  emit('update:modelValue', newValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (select('rejected'))),
      class: _normalizeClass(["p-2 rounded-md flex items-center justify-center gap-2 border-2 transition-colors", 
        _ctx.modelValue === 'rejected'
          ? 'border-primary30 bg-primary30/10'
          : 'border-gray-200 bg-gray-100 hover:border-gray-300'
      ])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-4 h-4 rounded-full border-2 flex items-center justify-center bg-white", _ctx.modelValue === 'rejected' ? 'border-primary30' : 'border-gray-400'])
      }, [
        (_ctx.modelValue === 'rejected')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true)
      ], 2),
      _hoisted_3
    ], 2),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (select('approved'))),
      class: _normalizeClass(["p-2 rounded-md flex items-center justify-center gap-2 border-2 transition-colors", 
        _ctx.modelValue === 'approved'
          ? 'border-negative bg-negative/10'
          : 'border-gray-200 bg-gray-100 hover:border-gray-300'
      ])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-4 h-4 rounded-full border-2 flex items-center justify-center bg-white", _ctx.modelValue === 'approved' ? 'border-negative' : 'border-gray-400'])
      }, [
        (_ctx.modelValue === 'approved')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : _createCommentVNode("", true)
      ], 2),
      _hoisted_5
    ], 2)
  ]))
}
}

})